var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames},[_c('img',{staticClass:"pdf-page-header",attrs:{"src":require("@/assets/report/report/pdf_logo.png"),"alt":""}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }